export default "__VITE_ASSET__BurhRzwB__"